import request from '../utils/request.js'

export default {
	getList(params) {
		return request.post(`kaodian/lists`, params).then(res => res.data);
	},
	add(params) {
		return request.post(`kaodian/add`, params).then(res => res.data);
	},
	edit(params) {
		return request.post(`kaodian/add`, params).then(res => res.data);
	},
	details(params) {
		return request.post(`kaodian/details`, params).then(res => res.data);
	},
	delete(params) {
		return request.post(`kaodian/del`, params).then(res => res.data);
	},
	selectList(params) {
		return request.post(`kaodian/selectlist`, params).then(res => res.data);
	},


}


// WEBPACK FOOTER //
// ./src/api/kaodian.js